"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var BaseAvatarInternal_1 = __importDefault(require("../../../../data-display/Avatar/BaseAvatarInternal"));
var TopBarAvatar = function (props) { return (react_1.jsx("div", { "data-6si-name": "top-bar--avatar" },
    react_1.jsx(BaseAvatarInternal_1.default, __assign({ placeholderType: "icon", name: props.name || '' }, props, { wrapperSize: 36, iconSize: 22, indicatorSize: 9, fontSize: 15 })))); };
TopBarAvatar.displayName = 'TopBar.Avatar';
exports.default = TopBarAvatar;
